import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth/index';

const getOnBoardDefaultDateFilter = () => {
  const start = new Date();
  start.setFullYear(start.getFullYear() - 1);
  start.setHours(0, 0, 0, 0);

  return [start.getTime(), new Date().setHours(0, 0, 0, 0)];
};

const initialState = {
  globalDateFilter: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  trafficDateFilter: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  liveClassesDateFilter: [
    new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  onBoardDateFilter: getOnBoardDefaultDateFilter(),
  testAndAssignmentDateFilter: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  ClassesDateFilter: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  globalDateFilterInstructor: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  liveClassesDateFilterInstructor: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  testAndAssignmentDateFilterInstructor: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  ClassesDateFilterInstructor: [
    new Date(new Date().getTime() - 10 * 24 * 60 * 60 * 1000).setHours(0, 0, 0),
    new Date().setHours(0, 0, 0),
  ],
  detailPage: [],
  yetToStart: [],
  detailPageCurrentTab: [],
  dashboardType: 'lms', // 'onboarding' or 'lms'
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalDateFilter: (state, action) => {
      state.globalDateFilter = action.payload;
    },
    setTrafficDateFilter: (state, action) => {
      state.trafficDateFilter = action.payload;
    },
    setLiveClassesDateFilter: (state, action) => {
      state.liveClassesDateFilter = action.payload;
    },
    setOnBoardDateFilter: (state, action) => {
      state.onBoardDateFilter = action.payload;
    },
    setTestandAssignmentDateFilter: (state, action) => {
      state.testAndAssignmentDateFilter = action.payload;
    },
    setClassesDateFilter: (state, action) => {
      state.ClassesDateFilter = action.payload;
    },
    setGlobalDateFilterInstructor: (state, action) => {
      state.globalDateFilterInstructor = action.payload;
    },
    setLiveClassesDateFilterInstructor: (state, action) => {
      state.liveClassesDateFilterInstructor = action.payload;
    },
    setTestandAssignmentDateFilterInstructor: (state, action) => {
      state.testAndAssignmentDateFilterInstructor = action.payload;
    },
    setClassesDateFilterInstructor: (state, action) => {
      state.ClassesDateFilterInstructor = action.payload;
    },
    setYetToStart: (state, action) => {
      state.yetToStart = action.payload;
    },
    setDetailPageCurrentTab: (state, action) => {
      state.detailPageCurrentTab = action.payload;
    },
    setDetailPage: (state, action) => {
      state.detailPage = action.payload;
    },
    setDashboardType: (state, action) => {
      state.dashboardType = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const {
  setGlobalDateFilter,
  setTrafficDateFilter,
  setLiveClassesDateFilter,
  setOnBoardDateFilter,
  setTestandAssignmentDateFilter,
  setClassesDateFilter,
  setGlobalDateFilterInstructor,
  setLiveClassesDateFilterInstructor,
  setTestandAssignmentDateFilterInstructor,
  setClassesDateFilterInstructor,
  setYetToStart,
  setDetailPageCurrentTab,
  setDetailPage,
  setDashboardType,
} = globalSlice.actions;

export const getGlobalDateFilter = (state) => state.global.globalDateFilter;
export const getTrafficDateFilter = (state) => state.global.trafficDateFilter;
export const getLiveClassesDateFilter = (state) =>
  state.global.liveClassesDateFilter;
export const getOnBoardDateFilter = (state) => state.global.onBoardDateFilter;
export const getTestandAssignmentDateFilter = (state) =>
  state.global.testAndAssignmentDateFilter;
export const getClassesDateFilter = (state) => state.global.ClassesDateFilter;
export const getGlobalDateFilterInstructor = (state) =>
  state.global.globalDateFilterInstructor;
export const getLiveClassesDateFilterInstructor = (state) =>
  state.global.liveClassesDateFilterInstructor;
export const getTestandAssignmentDateFilterInstructor = (state) =>
  state.global.testAndAssignmentDateFilterInstructor;
export const getClassesDateFilterInstructor = (state) =>
  state.global.ClassesDateFilterInstructor;
export const getYetToStart = (state) => state.global.yetToStart;
export const getDetailPage = (state) => state.global.detailPage;
export const getDetailPageCurrentTab = (state) =>
  state.global.detailPageCurrentTab;
export const getDashboardType = (state) => state.global.dashboardType;

export default globalSlice.reducer;
